import React from 'react';

import Modal from '~/components/modals/modal';

import styles from '~/components/modals/pest-type/pest-type-modal.module.scss';

const PestTypeYardModal = ({ onClose, isOpen }) => {
  return (
    <Modal onClose={onClose} isOpen={isOpen}>
      <Content />
    </Modal>
  );
};

const Content = () => (
  <div className={styles.pestTypeModal}>
    <p className={styles.pestTypeModalHeader}>
      Get rid of dozens of
      <br />
      household pests quickly
    </p>
    <div className={styles.pestModalBody}>
      <div className={styles.pestContainer}>
        <div className={styles.copyWrapper}>
          <p>Choose ants for:</p>
          <ul>
            <li>Argentine ants</li>
            <li>Crazy ants</li>
            <li>Crickets</li>
            <li>Cutworms</li>
            <li>Earwigs</li>
            <li>Field ants</li>
            <li>Foraging ants</li>
            <li>Little black ants</li>
            <li>Moisture ants</li>
            <li>Odorous house ants</li>
            <li>Pavement ants</li>
            <li>Pillbugs</li>
            <li>Sowbugs</li>
            <li>Sweet feeding ants</li>
            <li>Texas leafcutting ants</li>
            <li>Thief ants</li>
          </ul>
        </div>
      </div>
      <div className={styles.pestContainer}>
        <div className={styles.copyWrapper}>
          <p>Choose crawling, flies, other for:</p>
          <ul>
            <li>
              Ants (except fire ants, harvester ants, Pharaoh ants, and
              carpenter ants)
            </li>
            <li>Bed Bugs</li>
            <li>
              Beetles (carpet, darkling, dermestid, elmleaf, hide, leather,
              asian lady)
            </li>
            <li>Boxelder bugs</li>
            <li>Caterpillars</li>
            <li>Centipedes</li>
            <li>Clothes Moths</li>
            <li>Crickets</li>
            <li>Earwigs</li>
            <li>Firebrats</li>
            <li>House Flies</li>
            <li>Kudzu Bugs</li>
            <li>Non-biting Midges</li>
            <li>Millipedes</li>
            <li>Moths</li>
            <li>Pantry Pests</li>
            <li>Pillbugs</li>
            <li>Silverfish</li>
            <li>Sowbugs</li>
            <li>Stink Bugs (including brown marmorated stink bugs)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default PestTypeYardModal;
